import CityPageTemplate from "../city-template/CityPageTemplate";
import { valleyCityConfig } from "./data";

export default function ValleyCityPage() {
  return <CityPageTemplate config={valleyCityConfig} />;
}